export default __webpack_public_path__ + "static/ogImage-d8c81de608044b60e0e9494a91639c59.png";